const RUST = "#C14D28";

// Rust roof chevron — the "A" from the WriterHaus wordmark
export function LogoIcon({ size = 40, className = "" }) {
  const h = size * 0.78;
  return (
    <svg width={size} height={h} viewBox="0 0 100 78" fill="none" className={className} aria-hidden="true">
      <path d="M4 74 L50 6 L96 74 L73 74 L50 40 L27 74 Z" fill={RUST} />
    </svg>
  );
}

export function Logo({ size = 40, className = "" }) {
  return <LogoIcon size={size} className={className} />;
}

// Horizontal wordmark (cream WRITERHAUS with rust roof A)
export function Wordmark({ height = 24, className = "" }) {
  return (
    <img
      src="/brand/wordmark-v2.png"
      alt="WriterHaus"
      style={{ height, width: "auto" }}
      className={className}
      draggable="false"
    />
  );
}

export function LogoLockup({ iconSize = 120, className = "" }) {
  return (
    <div className={`flex flex-col items-start gap-4 ${className}`}>
      <Wordmark height={iconSize * 0.42} />
    </div>
  );
}
